var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper",on:{"click":function($event){return _vm.toDashboard()}}},[(_vm.logo)?_c('div',{style:({
      'padding-top': _vm.logoPadding[0] + 'px',
      'padding-right': _vm.logoPadding[1] + 'px',
      'padding-bottom': _vm.logoPadding[2] + 'px',
      'padding-left': _vm.logoPadding[3] + 'px'
    })},[_c('img',{class:_vm.isCircleLogo ? 'logo-img circle-logo' : 'logo-img',attrs:{"src":_vm.logo}})]):_c('div',{staticClass:"logo"},[_c('span',[_vm._v(_vm._s(_vm.$t('text.logo').toUpperCase()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }